let state = {
	gameOver: false,
	isPaused: false,
	player: {
		direction: 1,
		position: {
			x: 128,
			y: 128,
		},
		velocity: {
			x: 0,
			y: 0,
		},
		isSlippery: false,
		isGrounded: false,
		jumpCharge: 0,
		jumpAt: 1,
	},
	screenShakeIntensity: 0,
	level: {
		currentLevelIndex: 0,
		startedAt: performance.now(),
	},
}

export const defaultState: typeof state = structuredClone(state)

declare global {
	interface Window {
		walrus: typeof state
	}
}

export const updateState = (newState: Partial<typeof state>) => {
	state = { ...state, ...newState }
	if (process.env.NODE_ENV !== 'production') window.walrus = state
}
export const getLatestState = () => state

const gameState = {
	updateState,
	getLatestState,
}

export default gameState
